import { render, staticRenderFns } from "./DownloadProgress.vue?vue&type=template&id=51223e48"
import script from "./DownloadProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadProgress.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports